import React, {useState, useCallback} from 'react'
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import { FormattedMessage } from 'react-intl'

export default props => {
    useStyles(classes)
    const { productHooks } = props

    const [show, setShow] = useState(false)

    const { selectedProduct } = productHooks;

    const getDescription = useCallback(desc => {
        return desc?.replace(/font-size:\s*\d*.?\d*rem/g, '')
    }, [])
    
    return <div className={classes.Item}>
        <div className={`${classes.Hd} ${classes.DetailItemHd} ${show?classes.Active:""}`} onClick={()=>setShow(!show)}>
            <span className={classes.Title}><FormattedMessage id="item_features" defaultMessage="Product Features" /></span>
            <span className={classes.Icon}></span>
        </div>
        <div className={`${classes.Bd} ${classes.ModelStatureBd} ${show?classes.Active:""}`}>
            {
                show && selectedProduct?.itemFeatures && <div>
                    <div dangerouslySetInnerHTML={{__html:getDescription(selectedProduct?.itemFeatures)}}></div>
                </div>
            }
        </div>
    </div>
}